// Shared display formatters.
//
// Kept in a leaf module so any page/component can import without
// dragging in Leaflet, recharts, or other heavy deps that the
// page-level files (e.g. ParcelDetail) pull in.

/**
 * Format days-on-market for display.
 *
 * RentCast occasionally reports DOM measured against an original
 * listed_date from years ago (re-listing artifacts), e.g. 3043 days
 * ≈ 8.3 years. Showing "3043d" creates false signal — users think
 * the property has been sitting unsold for nearly a decade when
 * really the listing was relisted recently against a stale anchor.
 *
 * Cap: 730 days (2 years). Beyond that we show "2y+" to keep the
 * value compact and signal that the exact number isn't reliable.
 */
export function fmtDom(v) {
  if (v == null) return null;
  const n = Number(v);
  if (Number.isNaN(n) || n < 0) return null;
  if (n > 730) return '2y+';
  return `${n}d`;
}
